import { Component, OnInit, Input, Output, EventEmitter, OnChanges, NgZone, ChangeDetectorRef } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { ResponseChangeModel } from 'src/app/incident/incident.component';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';

@Component({
  selector: 'app-inputType-mul',
  templateUrl: './inputType-mul.component.html',
  styleUrls: ['./inputType-mul.component.scss']
,  standalone: false
})
export class InputTypeMulComponent implements OnInit, OnChanges {

  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() foregroundcolor: string;  
  @Input() TextColor: string; 
  //@Input() IsReadOnly?:boolean=false;
  @Input() IsReadOnly:boolean;

  @Input() isMatrix?: boolean=false;
  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  controlColor: string;
  IsHovered: boolean;
  @Input() showName?: boolean=true;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() conditionalChange: EventEmitter<ResponseChangeModel> = new EventEmitter<ResponseChangeModel>();

  changeColor:boolean = false;
  
  constructor(private cdr: ChangeDetectorRef, private zone: NgZone) {}
 
  ngOnChanges(changes: SimpleChanges) {
    if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion }; // Create a new reference to trigger change detection
      if (this.question.responseText && this.question.responseText.length > 0) {
        const arrResp = this.question.responseText.split("||");
        this.question.options.forEach(option => {
          option['selected'] = arrResp.indexOf(option.value) !== -1;
        });
      } else {      
        if (this.question.options) {
          this.question.options.forEach(option => option['selected'] = false);
        }      
      }
      
      this.CheckValidations();
      this.childQuestion.emit(this.question);
      this.cdr.markForCheck();      
    }
  }

  ngDoCheck()
  {
    if(this.question.errorMessage)
    {
       this.checkValidation();
    }
  }

  checkValidation()
  {
    this.errormgvisible = false;
      this.validationerrormessage = [];
    if (this.question.isQuestionRequired == "Y") {
      if (this.question["responseText"] == null || this.question["responseText"] == "") {
        this.errormgvisible = true;
        this.validationerrormessage.push("Input is mandatory");
        this.question["IsValid"] = false;
      }
    }
  }
  ngOnInit() {
    this.question["IsValid"] = true;
    this.validationerrormessage = [];
    this.errormgvisible = false;
    
   //Bind saved user response on load
   if(this.question.responseText && this.question.responseText.length>0)
   {
     let arrResp= this.question.responseText.split("||");
     let optSelected=[];
     this.question.options.forEach(function(x,y){
       if(arrResp.indexOf(x.value)!=-1)
       {
         optSelected.push(y);
       }
     });
      optSelected.forEach(x=>
      {
         this.question.options[x]["selected"]=true; 
         //this.foregroundcolor ="var(--main-color) !important; //#437cbc";this.TextColor = "white";       
      })

      if (this.question.isQuestionRequired == "Y" && optSelected.length>0) {
        this.question["IsValid"]=true;
        this.childQuestion.emit(this.question);
      }
   }

      this.checkForConsentScreen();
  }
  checkForConsentScreen() {
    if (this.question.isConsentQuestion && this.question.consentQuestionLabel != null && this.question.consentQuestionLabel.length > 0  ) {
      this.question.safeHtmlContent = this.question.consentQuestionLabel;
    }
  }
  OnMouseOver(event,question, option, index): void {
    event.target.style.backgroundColor = this.foregroundcolor;
    event.target.style.color=this.TextColor;
  }
  OnMouseOut(event,question, option, index): void {
    if (!question.options[index].selected) {
    event.target.style.backgroundColor = 'white';
    event.target.style.color="";
    }
  }

  selectOption(event,question, option, index) {
    this.changeColor = !this.changeColor;
    if (this.changeColor) {
      this.foregroundcolor ="var(--main-color) !important; //#437cbc";this.TextColor = "white";
      // event.target.style.backgroundColor = this.controlBGColor;
      // event.target.style.color="";
      question.options[index].selected = true  ;    
      event.target.style.backgroundColor = this.foregroundcolor;
      event.target.style.color=this.TextColor;     
    }
    else {  
       this.foregroundcolor ="white";this.TextColor = "";    
      event.target.style.backgroundColor = this.foregroundcolor;
      event.target.style.color=this.TextColor;
      question.options[index].selected = false;     
    }

    let optionStr = "";
    
    question.options.forEach(element => {
      if(element.selected)
      {
      optionStr += element.value + "||";
      }
    });
    this.validationerrormessage = [];
    optionStr = optionStr.substring(0, optionStr.length - 2);
    this.question["responseText"] = optionStr;

    if (this.question.isQuestionRequired == "Y") {
      if (this.question["responseText"] == null || this.question["responseText"] == "") {
        this.errormgvisible = true;
        this.validationerrormessage.push("Input is mandatory");
        this.question["IsValid"] = false;
      }
      else {
        this.errormgvisible = false;
        this.question["IsValid"] = true;
      }
    }
    else {
      this.errormgvisible = false;
      this.question["IsValid"] = true;
    }

    this.childQuestion.emit(this.question);    
  }

  onMultiChoiceOptionClick(event: MouseEvent, newValue: string, index: number) {

    // Prevent default radio button behavior to wait for parent's response
    event.preventDefault();
    event.stopPropagation();

    const updatedQuestion = { ...this.question };   
    updatedQuestion.options = [...this.question.options];
    updatedQuestion.options[index]["selected"] = !updatedQuestion.options[index]["selected"]; // Set the clicked option as selected  
   
    // Build the response text from selected options
    let pendingResponseText = "";
    updatedQuestion.options.forEach(element => {
      if (element["selected"]) {
        pendingResponseText += element.value + "||";
      }
    });
    
    // Remove the trailing "||" if exists
    if (pendingResponseText.length > 0) {
      pendingResponseText = pendingResponseText.substring(0, pendingResponseText.length - 2);
    }

    // // Set colors based on selected state
    // this.setOptionColors(event, updatedQuestion.options[index]["selected"]);


    // First emit the check event and wait for parent's decision from pop up if any conditonal questions are there 
    this.conditionalChange.emit({
      question: updatedQuestion,
      oldResponse: this.question.responseText,
      newResponse: pendingResponseText,
      proceed: (shouldProceed: boolean) => {
        this.zone.run(() => {
          if (shouldProceed) {
            // Update both the model and view state
            this.question.responseText = pendingResponseText;
            // Update radio button states
            this.question.options = this.question.options.map((opt, i) => ({
              ...opt,
              selected: i === index ? updatedQuestion.options[index]["selected"] : opt["selected"]
            }));
             
            this.inputChange.emit(true); // Emit input change event only when value changes
          }
          else {
            // If the parent component cancels the change, revert the model state.
            // If cancelled, revert everything
            updatedQuestion.options[index]["selected"] = !updatedQuestion.options[index]["selected"];
            //this.setOptionColors(event, updatedQuestion.options[index]["selected"]);
          
          }
            // Set colors based on selected state
            //this.setOptionColors(event, updatedQuestion.options[index]["selected"]);

          // Set colors based on selected state
          this.setOptionColors(event, updatedQuestion.options[index]["selected"]);

          // Force the view to update in both cases
          this.cdr.markForCheck();
          this.cdr.detectChanges();  
          // Run validations and emit changes
          // this.CheckValidations();        
          // this.childQuestion.emit(this.question);
        });
      }
    });
    this.CheckValidations();        
    this.childQuestion.emit(this.question);
  }
  setOptionColors(event: any, isSelected: boolean) {
    if (isSelected) {
      this.foregroundcolor = "var(--main-color) !important";
      this.TextColor = "white";
    } else {
      this.foregroundcolor = "white";
      this.TextColor = "";
    }
    event.target.style.backgroundColor = this.foregroundcolor;
    event.target.style.color = this.TextColor;
  }
  CheckValidations() {
    const isEmpty = !this.question.responseText;
    const isRequired = this.question.isQuestionRequired === "Y";
    
    this.question["IsValid"] = !(isRequired && isEmpty);
    this.errormgvisible = !this.question["IsValid"];
    this.validationerrormessage = this.errormgvisible ? [`Input is mandatory`] : [];
  }


}

